export default __webpack_public_path__ + "static/media/profilePic.d61adb66.jpeg";